<template>
  <div class="page__container">
    <BreadCrumbsTemplate />
    <ServicesTemplate v-if="!$route.params.target" />
    <router-view v-else />
  </div>
</template>

<script>
import BreadCrumbsTemplate from '@/components/BreadCrumbsTemplate.vue';
import ServicesTemplate from '@/components/ServicesTemplate.vue';

export default {
  name: "ServicesView",
  components: {
    BreadCrumbsTemplate,
    ServicesTemplate
  }
};
</script>